/** @format */

import React, { useRef, useState } from "react";
import { gsap } from "../../gsap";
import { SplitText } from "../../gsap/SplitText";
import { ScrollTrigger } from "../../gsap/ScrollTrigger.js";
import { useGSAP } from "../../gsap/react";
import AccordionSlide from "./AccordionSlide.jsx";

gsap.registerPlugin(SplitText, ScrollTrigger, useGSAP);
// ScrollTrigger.normalizeScroll(true);

const Accordion = () => {
  const accordionRef = useRef();
  const accordionTl = useRef();
  const curtainRef = useRef();
  const [activeIndex, setActiveIndex] = useState(8);
  const [active, setActive] = useState(false);

  const features = ["play", "unwind", "explore", "splash", "savor"];

  const resetAccordion = () => {
    setActive(false);
  };

  const AccordionItems = features.map((feature, idx) => {
    return (
      <AccordionSlide
        key={idx}
        id={feature}
        isActive={activeIndex === idx}
        setActive={() => {
          setActiveIndex(idx);
          setActive(true);
        }}
        onClick={() => {
          setActiveIndex(idx);
          setActive(true);
        }}
        resetActive={() => {
          setActive(false);
          setActiveIndex(8);
        }}
        initiated={active}
      />
    );
  });

  const fadeStyle = active ? "active" : "";

  useGSAP(
    () => {
      let mm = gsap.matchMedia();
      let splitHeadline = new SplitText("#header-accordion", { type: "chars, words" });

      mm.add("(min-width: 992px)", () => {
        gsap.set("#header-accordion", { opacity: 0 });
        gsap.set(curtainRef.current, { autoAlpha: 0 });
        accordionTl.current = gsap
          .timeline({
            scrollTrigger: {
              start: "top 80%",
              end: "+=150%",
              trigger: accordionRef.current
              // markers: true
            },
            paused: true,
            scrub: 0.5,
            reversed: true
          })
          .from(
            splitHeadline.chars,
            {
              duration: 0.65,
              x: 10,
              autoAlpha: 0,
              stagger: 0.05
            },
            "<"
          )
          .to("#header-accordion", { opacity: 1 }, "<")
          .fromTo(
            ".box",
            { y: 200, opacity: 0 },
            {
              y: 0,
              opacity: 1,
              stagger: 0.2,
              delay: 1
            },
            ">-=1"
          )
          .to(".curtain", { autoAlpha: 1 }, "<")
          .to(".curtain", { opacity: 0, delay: 1 }, ">")
          .to(".curtain", { height: 0 }, ">");
      });
    },
    { scope: accordionRef }
  );
  return (
    <section
      id="section-accordion"
      ref={accordionRef}
      className="w-full z-[100] relative bg-transparent"
      data-tag="section_2_accordion"
      data-pixel="carni040+unique"
    >
      <div id="headline-accordion" className={`text-white text-center pt-5 ` + fadeStyle}>
        <h2
          id="header-accordion"
          className="text-center text-[24px] leading-[36px] lg:text-[45px] lg:leading-[60px] drop-shadow-2xl font-thin absolute top-[34px] z-[9999] left-1/2 -translate-x-1/2 w-full"
          aria-label="Relax, play or do it all. Paradise is waiting for you"
        >
          <span aria-hidden="true">
            {" "}
            <span className="block">Relax, play, or do it all.</span>
            Paradise is waiting for you.
          </span>
        </h2>
      </div>

      <div className="relative">
        {" "}
        <div
          ref={curtainRef}
          className="curtain hidden lg:block absolute w-full h-full top-0 left-0 bg-dark-blue/20 z-50"
        ></div>
        <ul
          id="section-destination"
          className="accordion bg-dark-blue overflow-hidden justify-end flex lg:justify-center lg:flex h-screen"
          onMouseLeave={() => resetAccordion()}
        >
          {AccordionItems}
        </ul>
      </div>
    </section>
  );
};

export default Accordion;
